module.exports = __webpack_public_path__ + "static/media/prev-icon.2f3616bb.svg";